<header class="header-content w-100">
  <div class="container max-w-100 w-100 pt-8 pb-20">
    <div class="flex align-items-center justify-content-between">
      <div class="flex align-items-center pl-16 pr-20 pt-12">
        <ng-content></ng-content>
        <img
          src="./assets/img/logo-passer-morado.png"
          alt="passer"
          class="h-20px marg-title" />
      </div>
      <div class="flex align-items-center justify-content-end">
        <div class="copny-select flex align-items-center radius-8 bg-white mr-20">
          <ps-menu class="w-100" menuClass="w-100" menuId="menu-header" [hasHeaderContent]="true">
            <div class="header flex align-items-center w-100 button-menu-copny bg-transparent">
              <img alt="avatar" class="h-40px w-40px mr-10" [src]="getImage()" />
              <p class="button-menu-copny__text f13 color-psr-text-color text-left inline-block m-0 text-ellipsis">
                {{ getNameUser() }}
              </p>
              <ps-icon class="arrow-down" [srcIcon]="icons.arrowDropDown"></ps-icon>
            </div>
            <div class="container menu-copny-header">
              <div class="pt-8 px-16 pb-16">
                <p class="f13 m-0 mb-4">{{ 'global.logWith' | translate }}</p>
                <app-title-desc
                  classDesc="f11 m-0 color-psr-radio-button-bg-87"
                  classTitle="f11 m-0"
                  [desc]="getEmailUser()"
                  [title]="getNameUser()">
                </app-title-desc>

                <!-- TODO - WAITING FOR DARKTHEME TO BE BETTER -->
                <!-- <div class="mt-16 flex align-items-center">
                  <app-box [classDiv]="'w-30px h-30px radius-5 mr-8 background-dark-style flex align-items-center justify-content-center pointer'"
                    (click)="changeTheme(true)">
                    <i class="fas fa-moon color-psr-text-dark-style"></i>
                  </app-box>
                  <app-box [classDiv]="'w-30px h-30px radius-5 background-light-style flex align-items-center justify-content-center pointer'"
                    (click)="changeTheme(false)">
                    <i class="fas fa-sun color-psr-text-light-style"></i>
                  </app-box>
                </div> -->

                <div class="divider my-16"></div>

                <div class="flex align-items-center justify-content-between w-100">
                  <ps-button
                    buttonClass="f14 pl-16 pr-20"
                    data-testid="btn-logout"
                    height="tall"
                    rounded="three-parts-rounded"
                    width="auto"
                    (onClick)="logOut()">
                    <span class="flex align-items-center">
                      <ps-icon
                        iconClass="mr-12"
                        iconColor="white"
                        iconSize="xsmall"
                        [srcIcon]="icons.logOut">
                      </ps-icon>
                      {{ 'login.logOut'| translate }}
                    </span>
                  </ps-button>
                  <p class="f11 m-0">
                    {{ 'labels.version' | translate }} {{ test }}: {{ version }}
                  </p>
                </div>
              </div>
            </div>
          </ps-menu>
        </div>
      </div>
    </div>
  </div>
</header>
